import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Picker from "react-month-picker";

class MonthBox extends Component {
    static propTypes = {
        value: PropTypes.string,
        onClick: PropTypes.func,
    }

    constructor(props) {
        super(props)

        this.state = {
            value: this.props.value || 'N/A',
        }
    }

    static getDerivedStateFromProps(props, state) {
        return {
            value: props.value || 'N/A',
        }
    }

    render() {

        return (
            <div className="box" onClick={this._handleClick}>
                <label>{this.state.value}</label>
            </div>
        )
    }

    _handleClick = (e) => {
        this.props.onClick && this.props.onClick(e)
    }
}


class MonthList extends Component {
    constructor(props) {
        super(props);
        let firstYear = 2010;
        const daysRendered = Array(50)
        .fill(0)
        .map(() => firstYear += 1);

        this.state = {
            yearsOfSingle: daysRendered,
            ageOfSingle: 0,
            singleValue: { year: props.yearSelected, month: props.monthSelected },
        }

        this.yearsPanel = React.createRef()
        this.pickAMonth = React.createRef()
    }

    render() {
        const pickerLang = {
            months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            from: 'From', 
            to: 'To',
        }
        const { yearsOfSingle, ageOfSingle, singleValue } = this.state

        const makeText = m => {
            if (m && m.year && m.month) {
                return pickerLang.months[m.month - 1] + '. ' + m.year;
            }
            return '?'
        }

        return (
            <Picker
                ref={this.pickAMonth}
                age={ageOfSingle}
                years={yearsOfSingle}
                value={singleValue}
                lang={pickerLang.months}
                onChange={this.handleAMonthChange}
                onDismiss={this.handleAMonthDissmis}
            >
                <MonthBox value={makeText(singleValue)} onClick={this.handleClickMonthBox} />
                <h3 onClick={this.handleClickMonthBox}> (Click to change date)</h3>
            </Picker>
        )
    }

    handleClickEditYears = (e) => {
        this.yearsPanel.current.show()
    }
    handleYearsChanged = (years) => {
        this.setState({
            yearsOfSingle: years.concat(),
            ageOfSingle: this.state.ageOfSingle + 1,
        })
    }

    handleClickMonthBox = (e) => {
        this.pickAMonth.current.show()
    }
    handleAMonthChange = (year, month) => {
        this.props.onMonthChange(year, month);
        this.pickAMonth.current._onDismiss();

    }
    handleAMonthDissmis = (value) => {
        this.setState({ singleValue: value })
    }
}

class MonthPicker extends Component {
    static propTypes = {
        onMonthChange: PropTypes.func,
        monthSelected: PropTypes.number,
        yearSelected: PropTypes.number,
    }

    render() {

        return <MonthList {...this.props} />;
    }
}

export default MonthPicker;
